import apiClient from '../api/apiClient';

/**
 * Pre-IPO fake inventory (lots visible to FE until payment; real inventory is added elsewhere).
 */
class FakeInventoryService {
  /**
   * @param {string} productId
   * @returns {Promise<object>} API envelope { success, data, message, error }
   */
  async getSummary(productId) {
    const response = await apiClient.get(`/api/v1/admin/fake-inventory/${productId}/summary`);
    return response.data;
  }

  /**
   * @param {string} productId
   * @param {{ page?: number, limit?: number }} params
   */
  async getLots(productId, params = {}) {
    const response = await apiClient.get(`/api/v1/admin/fake-inventory/${productId}/lots`, {
      params,
    });
    return response.data;
  }

  /**
   * @param {string} productId
   * @param {{ supplier_price: number, quantity: number, inventory_date: string }} payload - inventory_date YYYY-MM-DD
   */
  async addLot(productId, payload) {
    const response = await apiClient.post(`/api/v1/admin/fake-inventory/${productId}/lots`, payload);
    return response.data;
  }
}

const fakeInventoryService = new FakeInventoryService();
export default fakeInventoryService;
